import { ClienteMacroseg } from '../../model/cliente-macroseg/cliente-macroseg';

/**
 * Puerto Abstracto: ClienteMacrosegRepository
 * 
 * Define el contrato para gestión de macrosegmentaciones de cliente.
 * Migrado desde: FilterProgramarServiciosViewImpl.java
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpClienteMacrosegRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class ClienteMacrosegRepository {

  /**
   * Obtiene las macrosegmentaciones activas filtradas por cliente.
   * 
   * @param nmconsecutivoCliente Código del cliente (aseguradora)
   * @returns Lista de macrosegmentaciones activas
   */
  abstract obtenerMacrosegmentaciones(
    nmconsecutivoCliente: number
  ): Promise<ClienteMacroseg[]>;
}
